import { useMediaQuery } from "@uidotdev/usehooks"
import Bell from "assets/icons/system/Bell"
import BellRing from "assets/icons/system/BellRing"
import BookClosed from "assets/icons/system/BookClosed"
import BookOpen from "assets/icons/system/BookOpen"
import HomeLine from "assets/icons/system/HomeLine"
import HomeSmile from "assets/icons/system/HomeSmile"
import clsx from "clsx"
import Link, { NavBackground } from "components/Navigation/Link"
import { useNotifications } from "features/Notifications/hooks/useNotifications"
import { GraduationCap, Page } from "iconoir-react"
import { useRef } from "react"
import routes from "routes"

import styles from "./BottomNavigation.module.css"

const BottomNavigation = () => {
  const is2XS = useMediaQuery("(max-width: 500px)")
  const { pageOverview } = useNotifications({
    useSearchParams: false,
    enableNotificationList: false,
  })
  const { data: notificationOverviewData } = pageOverview
  const hasNotification =
    notificationOverviewData && notificationOverviewData.all > 0

  const navContainerRef = useRef<HTMLDivElement>(null)

  return (
    <nav
      id="bottomNavigation"
      className={clsx(
        "fixed bottom-0 z-navbar w-full bg-white py-1",
        styles.bottomNavigation,
        {
          "p-1": is2XS,
        }
      )}
    >
      <div
        ref={navContainerRef}
        className="relative flex w-full items-center justify-around"
      >
        <NavBackground containerRef={navContainerRef} />
        <Link
          href={routes.home}
          text="Home"
          icon={<HomeLine />}
          activeIcon={<HomeSmile />}
        />
        <Link
          href={routes.learning}
          text="Learning"
          icon={<BookClosed />}
          activeIcon={<BookOpen />}
        />

        <Link
          href={routes.masterclasses}
          text="Masterclasses"
          className="mb-[2.5px]"
          icon={<GraduationCap height={22} width={22} />}
          activeIcon={
            <GraduationCap height={22} width={22} className="mb-[2.5px]" />
          }
        />
        <Link
          href={routes.cpat.dashboard}
          text="CPAT"
          icon={<Page fontSize={13} className="mb-0.5" />}
          activeIcon={<Page fontSize={13} className="mb-0.5" />}
        />
        <div className={clsx({ relative: hasNotification })}>
          <Link
            href={routes.notifications}
            text="Notifications"
            icon={<Bell />}
            activeIcon={<BellRing />}
          />
          {hasNotification && (
            <span
              className={clsx(
                "absolute -right-0.5 inline-flex  items-center justify-center rounded-full bg-critical-500 px-0.5 text-xs font-semibold text-common-white-500",
                { "-top-0.75": !is2XS, "top-0": is2XS }
              )}
            >
              {notificationOverviewData.all}
            </span>
          )}
        </div>
      </div>
    </nav>
  )
}

export default BottomNavigation
